import React from "react";
import { Box, Button } from "@mui/material";
import { useSelector } from "react-redux";
import VoiceMicButton from "../../components/VoiceMicButton";
function formatFields(arr) {
  return arr.map(item => {
    // If already an object, return as is
    if (typeof item === "object" && item !== null) {
      return item;
    }

    // Convert string to object
    return {
      label: item.charAt(0).toUpperCase() + item.slice(1)?.replaceAll("_", " "),
      key: item
    };
  });
}
const SearchBar = ({
  bylist = [],
  label,
  btnLabel,
  handleSearch,
  sx = {}
}) => {
  const [filterValue, setFilterValue] = React.useState("");
  const [filterField, setFilterField] = React.useState("Search by");
  const user = useSelector((state) => state?.loginState?.auth);
  let ff = formatFields(bylist)
  let list = [{ label: "Search by", key: "Search by" }].concat(ff)

  const selectedItem = list.find(item => item.key === filterField);
  const showInput = selectedItem && !selectedItem.hideInput;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        width: "100%",
        mb: 2.5,
        ...sx
      }}
    >
      <select
        value={filterField}
        onChange={(e) => setFilterField(e.target.value)}
        style={{
          height: '40px',
          width: '160px',
          flexShrink: 0,
          padding: '0 12px',
          borderRadius: '8px',
          border: '1px solid #cbd5e1',
          backgroundColor: '#ffffff',
          fontSize: '13px',
          fontWeight: 500,
          color: '#1e293b',
          outline: 'none',
          cursor: 'pointer'
        }}
      >
        {list.map((b, idx) => <option key={idx} value={b?.key}>{b?.label}</option>)}
      </select>
      
      {showInput && filterField !== "Search by" && (
        <div style={{ position: 'relative', flex: 1, display: 'flex', alignItems: 'center', minWidth: '180px' }}>
          <input
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            placeholder="Search value..."
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch(filterField, filterValue);
              }
            }}
            style={{
              height: '40px',
              padding: '0 38px 0 14px',
              borderRadius: '8px',
              border: '1px solid #cbd5e1',
              backgroundColor: '#ffffff',
              fontSize: '13px',
              color: '#1e293b',
              outline: 'none',
              width: '100%'
            }}
          />
          <div style={{ position: 'absolute', right: 6, zIndex: 5 }}>
            <VoiceMicButton
              initialText={filterValue}
              onTranscript={(text) => setFilterValue(text)}
              size={15}
            />
          </div>
        </div>
      )}

      <Button
        variant="contained"
        onClick={() => filterField !== "Search by" ? handleSearch(filterField, filterValue) : () => { }}
        sx={{
          height: '40px',
          px: 2.5,
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '13px',
          borderRadius: '8px',
          background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
          boxShadow: '0 2px 4px rgba(37, 99, 235, 0.2)',
          whiteSpace: 'nowrap',
          flexShrink: 0,
          '&:hover': {
            background: 'linear-gradient(135deg, #1d4ed8, #1e40af)',
          }
        }}
      >
        Search
      </Button>
    </Box>
  );
};

export default SearchBar;
